import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import AgapeTypography from '../AgapeTypography';

const useStyle = makeStyles(() => ({
  root: {
    width: '100%',
    textAlign: 'center',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    lineHeight: '0.1em',
    margin: '10px 0 20px',
  },
  inner: {
    padding: '0 10px',
    lineHeight: 'inherit',
  },
}));
const MiddleText = ({ children, ...props }) => {
  const classes = useStyle();

  return (
    <AgapeTypography className={classes.root}>
      <AgapeTypography
        variant="quote"
        component="span"
        {...props}
        className={classes.inner}
      >
        {children}
      </AgapeTypography>
    </AgapeTypography>
  );
};

export default MiddleText;
